import { useState } from "react";

import useSingleLead from "../../../data/useSingleLead";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { ILead } from "../../../models/Lead";
import Card from "../../shared/Card/Card";

export default function VehicleNotes({ lead }: { lead: ILead }) {
  const { update } = useSingleLead(lead.id);
  const { saveHandlers } = useDefaultCRUDHandlers("Vehicle Notes");
  const [vehicleNotes, setVehicleNotes] = useState(lead.vehicleNotes);

  const handleSaveVehicleNotes = () => {
    const updatedLead = {
      ...lead,
      vehicleNotes: vehicleNotes ?? ""
    };

    update.mutate(updatedLead, saveHandlers)
  }

  return (
    <Card title="Vehicle Notes" bodyClassName="p-4">
      <div className="space-y-4">

        <textarea
          className="w-full"
          rows={5}
          defaultValue={lead.vehicleNotes ?? ""}
          onChange={(e) => setVehicleNotes(e.target.value)}
          onBlur={() => handleSaveVehicleNotes()}
        />

        <button
          className="rounded-md border border-transparent bg-gp-blue-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-gp-blue-700"
          onClick={() => handleSaveVehicleNotes()}
        >
          Update
        </button>

      </div>
    </Card>
  );
}
